async function apiFetch(url, authToken) {
  const response = await fetch(url, {
    headers: { 'Authorization': 'Bearer ' + authToken }
  });
  if (response.status === 401) {
    throw new Error('UNAUTHORIZED');
  }
  return response.json();
}

export async function getAllFunds(authToken, userId, theDate, version = '') {
  return apiFetch(
    process.env.VUE_APP_ROOT_API + '/api' + version + '/myfunds/' + userId + '/' + theDate,
    authToken
  );
}

export async function getRevolutionFundData(authToken, theDate, version = '') {
  return apiFetch(
    process.env.VUE_APP_ROOT_API + '/api' + version + '/revolutionfund/' + theDate,
    authToken
  );
}

export async function getCompanyFundData(authToken, theDate, version = '') {
  return apiFetch(
    process.env.VUE_APP_ROOT_API + '/api' + version + '/companyfunds/' + theDate,
    authToken
  );
}

export async function getCompanyPerformanceData(authToken, version = '') {
  return apiFetch(
    process.env.VUE_APP_ROOT_API + '/api' + version + '/companyperformance',
    authToken
  );
}

export async function getDailyInvestmentData(authToken, theDate, version = '') {
  return apiFetch(
    process.env.VUE_APP_ROOT_API + '/api' + version + '/dailyinvestments/' + theDate,
    authToken
  );
}

export async function getDailyInvestmentDataForRevFund(authToken, theDate, version = '') {
  return apiFetch(
    process.env.VUE_APP_ROOT_API + '/api' + version + '/dailyinvestmentsrevfund/' + theDate,
    authToken
  );
}
